import {
  Button,
  Flex,
  MenuIcon,
  Text,
  Tooltip
} from '@fluentui/react-northstar';
import { Icon } from '@fluentui/react/lib/Icon';
import React, { useEffect, useState } from 'react';
import logo from './../../../images/tikit-logo.png';
import AppCSS from './../../App.module.css';

import { Toggle } from '@fluentui/react';
import { Login } from '@microsoft/mgt-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { appState, AppStateContext } from '../../AppState';
import { getCachedFeature } from '../../shared/cache/FeatureCache';
import { TicketBoardMobileMenu } from '../../shared/components/TicketBoardMobileMenu';
import { platformService } from '../../shared/services/platform.service';
import { ADMINISTRATORS, AGENTS, ANALYSTS, IsAgentToggleStyle, KNOWLEDGEAGENT, KNOWLEDGEREADER, LICENSE_FEATURE, UserAdminMode } from '../../shared/utils/constants';
import { i18n } from '../../shared/utils/helper';



const { t } = i18n();

interface Props {
  active?: number;
}

export const Nav = (props: Props) => {
  
  const appContextState = appState();
  const api = new platformService();
  const {t} = useTranslation();

  const [showIsAdminMode, setShowIsAdminMode] = useState(false);
  const [isAdminMode, setIsAdminMode] = useState(true);
  const [currentUser, setCurrentUser] = useState<string>('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    (function retryNotExist() {
      if (!document.querySelector('mgt-login')) {
        return setTimeout(retryNotExist);
      }

      let mgtLoginSelector = document.querySelector('mgt-login').shadowRoot;
      if (!mgtLoginSelector.querySelector('mgt-person')) {
        return setTimeout(retryNotExist);
      }

      let mgtPerson = mgtLoginSelector.querySelector('mgt-person').shadowRoot;
      if (mgtPerson.querySelector('.line1')) {
        mgtPerson
          .querySelector('.line1')
          .setAttribute('style', 'display: none');
      }

      let mgtflyout = mgtLoginSelector.querySelector('mgt-flyout');

      mgtflyout
        .querySelector('.popup-command')
        .setAttribute('style', 'color:var(--teams-font-color)');

      if (mgtPerson.querySelector('.person-root img') !== null) {
        mgtPerson
          .querySelector('.person-root img')
          .setAttribute('style', 'cursor: pointer');
      }

      mgtLoginSelector
        .querySelector('.login-button')
        .setAttribute(
          'style',
          '--background-color--hover: rgba(255,255,255,0.3);'
        );
    })();
  }, [currentUser]);

  useEffect(()=>{
    if (appContextState.me)
    {
       (async ()=>{
          const isScopingEnabled = await getCachedFeature(LICENSE_FEATURE.PermissionScoping);
          const isAgentModeEnabled = isScopingEnabled && (appContextState?.userRoles?.roles?.includes(ADMINISTRATORS) || appContextState?.userRoles?.roles?.includes(ANALYSTS) || appContextState?.userRoles?.roles?.includes(KNOWLEDGEAGENT));
          if (isAgentModeEnabled) 
          {
            setShowIsAdminMode(isAgentModeEnabled);
            let isAdminMode = appContextState.me.Claims.find((claim: any) => claim.startsWith('isAdminMode: True'))
            setIsAdminMode(isAdminMode);
          }
        })();
    }
   
  },[appContextState.me]);

  const clearTokenOnLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("accessToken");
  }

  const goToHelpTikit = () => {
    window.open('https://kb.cireson.com/tikit-knowledge-articles', '_blank');
  };

  const hasNavAccess = appContextState.userRoles.roles.includes(ADMINISTRATORS) || appContextState.userRoles.roles.includes(ANALYSTS) ||
    appContextState.userRoles.roles.includes(AGENTS) || appContextState.userRoles.roles.includes(KNOWLEDGEAGENT) ||
    appContextState.userRoles.roles.includes(KNOWLEDGEREADER);

  const renderAdminModeToggle = (wrapperClassName: string) => (
    <div className={wrapperClassName}>
      <Toggle
        checked={isAdminMode}
        style={{...IsAgentToggleStyle.Toggle,...(isAdminMode ? IsAgentToggleStyle.IsAdminMode: IsAgentToggleStyle.IsAgentMode)}}
        onChange={async (_ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
          setIsAdminMode(checked);
          await api.updateIsAgentMode(checked ? UserAdminMode.Admin : UserAdminMode.Agent);
          await api.resetUserClaims();
          location.reload();
        }}
      />
      <Text content={t("ticket.toolbar.admin-mode")} styles={{position:"relative", top:"2px", color: isAdminMode ? "white" : "grey",fontWeight:600}}/>
    </div>
  );

  return (
    <AppStateContext.Consumer>
      {state => {
        return (
          <>
            <div className={`block md:hidden`}>
              {isMenuOpen && (
                <TicketBoardMobileMenu
                  active={props.active}
                  menuClose={() => {
                    setIsMenuOpen(false);
                  }}
                />
              )}
            </div>
            <Flex
              space="between"
              className={`items-center ${state.theme === 'teamsDarkTheme' ? 'border-b': ''} print-hidden`}
              style={{backgroundColor: '#222', borderColor: 'rgba(255,255,255,0.3)'}}
            >
              <Flex.Item>
                <Flex>
                  {hasNavAccess && (
                    <Flex.Item>
                      <div
                        className={`action-button flex items-center pl-3`}
                      >
                        <Button
                          primary
                          text
                          icon={<MenuIcon size="large" />}
                          title="Edit"
                          size="medium"
                          iconOnly
                          onClick={() => {
                            setIsMenuOpen(true);
                          }}
                          className={`${AppCSS.navActionButton} mr-1 ml-1 lg-hidden-important`}
                          style={{color: 'white'}}
                        />
                      </div>
                    </Flex.Item>
                  )}
                  <Flex.Item>
                    <div className={`action-button flex items-center pl-3 mt-1`}>
                      <img src={appContextState.teamsConfig?.CompanyLogoUrl === "" ? logo : appContextState.teamsConfig?.CompanyLogoUrl} style={{ height: '20px' }} />
                    </div>
                  </Flex.Item>
                </Flex>
              </Flex.Item>

              {showIsAdminMode && hasNavAccess && renderAdminModeToggle('flex md:hidden flex-grow justify-center items-center gap-1')}

              <Flex.Item>
                <Flex gap="gap.medium" vAlign="center">
                    {hasNavAccess && (
                      <Flex gap="gap.large">
                        {showIsAdminMode && renderAdminModeToggle('hidden md:flex items-center gap-2')}

                        <div className="hidden md:block">
                          <Tooltip
                            content={t("common.settings")}
                            trigger={
                              <Link to="/settings">
                                <Icon
                                  iconName="Settings"
                                  className={`text-lg text-white cursor-pointer`}
                                />
                              </Link>
                            }
                          />
                        </div>

                      <Tooltip
                        content={t("common.help-center")}
                        trigger={
                          <Icon
                            iconName="Help"
                            className={`text-lg text-white cursor-pointer`}
                            onClick={goToHelpTikit}
                          />
                        }
                      />

                      </Flex>
                    )}
                  <div className={`action-button cursor-pointer`}>
                    <Login className={`${state.theme === 'teamsDarkTheme' ? 'login-popup-dark': ''}`} logoutCompleted={clearTokenOnLogout}/>
                    {state.userImages && setCurrentUser(state.currentUserEmail)}
                  </div>
                </Flex>
              </Flex.Item>
            </Flex>
          </>
        );
      }}
    </AppStateContext.Consumer>
  );
};
